import Vue from 'vue'
import Router from 'vue-router'
import vbclass from 'vue-body-class'
import _ from 'lodash'

import loginContainer from '@/components/login/loginContainer'
import loginInput from '@/components/login/inputs/loginInput'
import forgotPassword from '@/components/login/inputs/forgotPasswordInput'
import oidcError from '@/components/login/inputs/oidcError'
import PostLogout from '@/components/login/inputs/PostLogout'
import expired from '@/components/login/inputs/expired'
import doubleLogin from '@/components/login/inputs/doubleLogin'
import PasswordReset from '@/components/login/inputs/PasswordReset'
import loginMfa from '@/components/login/inputs/loginMfa'
import setupMfa from '@/components/login/inputs/setupMfa'
import authenticated from '@/components/authenticated'
import documentGrid from '@/components/grid/documentGrid'
import VersionGrid from '@/components/grid/versionGrid'
import treeview from '@/components/treeView/treeView'
import treeViewOldApi from '@/components/treeViewOldApi/treeView'
import toolbar from '@/components/toolBar/toolBar'
import newFolder from '@/components/folder/newFolderOldApi'
import UsersInformation from '@/components/userControls/management/UsersInformation'
import folderProperties from '@/components/folder/folderProperties'
import folderRights from '@/components/folder/folderRights'
import oneTwoBuildNotifySales from '@/components/oneTwoBuildNotifySales'
import * as sessionApi from 'api/sessionApi'
import * as settingsApi from 'api/settingsApi'
import CommentAttachmentDownload from '@/components/comment/CommentAttachmentDownload'

const VueRouter = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/login',
      name: '',
      component: loginContainer,
      meta: { bodyClass: 'p-login' },
      children:
      [
        {
          path: '/',
          name: 'login',
          components: {
            loginOptions: loginInput
          },
          meta: { public: true }
        },
        {
          path: '/forgotpassword',
          name: 'forgotPassword',
          components: {
            loginOptions: forgotPassword
          },
          meta: { public: true }
        },
        {
          path: '/oidcerror',
          name: 'oidcError',
          components: {
            loginOptions: oidcError
          },
          meta: { public: true }
        },
        {
          path: '/loggedout',
          name: 'loggedOut',
          components: {
            loginOptions: PostLogout
          }
        },
        {
          path: '/expired',
          name: 'expired',
          components: {
            loginOptions: expired
          },
          meta: { public: true }
        },
        {
          path: '/doublelogin',
          name: 'doublelogin',
          components: {
            loginOptions: doubleLogin
          },
          meta: { public: true }
        },
        {
          path: '/passwordreset',
          name: 'passwordreset',
          components: {
            loginOptions: PasswordReset
          },
          meta: { public: true }
        },
        {
          path: '/loginmfa',
          name: 'loginmfa',
          components: {
            loginOptions: loginMfa
          },
          meta: { public: true }
        },
        {
          path: '/setupmfa',
          name: 'setupmfa',
          components: {
            loginOptions: setupMfa
          },
          meta: { public: true }
        }
      ]
    },
    {
      path: '/authenticated',
      name: 'authenticated',
      component: authenticated,
      meta: { public: true, bodyClass: 'p-authenticated' }
    },
    {
      path: '/usercontrols/documents/documentApi',
      name: 'documentGrid',
      component: documentGrid,
      meta: { public: true }
    },
    {
      path: '/usercontrols/documents/versiongrid/:folderId/:docId',
      name: 'versionGrid',
      component: VersionGrid,
      meta: { public: true }
    },
    {
      path: '/folder/newfolder/:id',
      name: 'newfolder',
      component: newFolder
    },
    {
      path: '/treeView',
      name: 'treeView',
      component: treeview
    },
    {
      path: '/usercontrols/tree/treeViewOldApi',
      name: 'treeViewOldApi',
      component: treeViewOldApi
    },
    {
      path: '/toolBar',
      name: 'toolBar',
      component: toolbar,
      meta: { public: true }
    },
    {
      path: '/UserControls/Management/UsersInformation',
      name: 'usersInformation',
      component: UsersInformation
    },
    {
      path: '/folder/folderProperties/:id',
      name: 'folderproperties',
      component: folderProperties
    },
    {
      path: '/folder/folderRights/:id',
      name: 'folderRights',
      component: folderRights,
      meta: { bodyClass: 'p-folder-rights' }
    },
    {
      path: '/12Build/activationNotification/',
      name: '12BuildNotifySales',
      component: oneTwoBuildNotifySales
    },
    {
      path: '/comment/downloadattachments/:commentId/:userId/:hash',
      name: 'CommentAttachmentDownload',
      component: CommentAttachmentDownload,
      meta: { public: true }
    }
  ]
})

let postAuthRoute = null

export const getPostAuthRoute = function () {
  return postAuthRoute
}

// Setup sync with store.
VueRouter.beforeEach((to, from, next) => {
  // Takeover query parameters from the previous route and multiple routes were matched.
  // This is needed because the login page always has 2 matches because of routes and 2 matches are needed for loading multiple components.
  if (!_.isEmpty(from.query) && to.matched.length > 1) {
    _.merge(to.query, from.query)
  }
  if (to.fullPath === '/') {
    window.location = '/index.aspx'
  } else {
    postAuthRoute = { name: to.name, params: to.params, query: to.query }
  }
  // User was redirected to login page
  if (to.meta.public || to.path === '/' || to.path === '/loggedout') {
    next()
  } else {
    // Validate user session
    sessionApi.validate().then(active => {
      if (active) {
        next()
      } else {
        // Store the target route for redirection after post.
        postAuthRoute = { name: to.name, params: to.params, query: to.query }
        // Navigate to login instead.
        next({ name: 'login' })
      }
    }).catch(() => {
      // Navigate to login instead.
      next({ name: 'login' })
    })
  }
})

VueRouter.afterEach((to, from) => {
  // We want to show clientName in the page's title for the login page only.
  if (to.path.startsWith('/login')) {
    Vue.nextTick().then(function () {
      settingsApi.getTitle().then(result => {
        document.title = result
      })
    })
  }
})

export default VueRouter

Vue.use(Router)
Vue.use(vbclass, VueRouter)



// WEBPACK FOOTER //
// ./src/router/index.js